import { useQuery, UseQueryResult } from "@tanstack/react-query";
import {
  StakeFiatCurrency,
  StakeOptionList,
} from "@nestcoinco/hyper-api-gateway-api-client";

import { QUERY_KEYS } from "../constants";
import { handleGetStakeOptions } from "../../api-clients/tournamentsStakeOptionsClient";

const DEFAULT_STALE_TIME = 60 * 60 * 1000; //1 hour

interface UseStakeOptionsQueryParams {
  staleTime?: number;
  enabled?: boolean;
  currency?: StakeFiatCurrency;
}

function useStakeOptionsQuery(
  params?: UseStakeOptionsQueryParams
): UseQueryResult<StakeOptionList | undefined, Error> {
  const {
    currency,
    staleTime = DEFAULT_STALE_TIME,
    enabled = true,
  } = params || {};

  const query = useQuery({
    queryKey: [QUERY_KEYS.TOURNAMENT.STAKE_OPTIONS],
    queryFn: () => handleGetStakeOptions(currency),
    staleTime,
    enabled,
  });

  return query;
}
export default useStakeOptionsQuery;
